import { BottomSheetDialog } from '@medely/web-components';
import React from 'react';
import { CalendlyModalProps } from './interface';
import useDevice from '@mp/hooks/useDevice.web';
import { PhoneScreeningSchedulerForm } from './PhoneSchedulerForm.web';

export const CalendlyModal = ({ open, onClose }: CalendlyModalProps) => {
  const isDesktop = useDevice() === 'desktop';

  return (
    <BottomSheetDialog
      isDesktop={isDesktop}
      sx={{ alignSelf: isDesktop ? 'center' : 'end' }}
      open={open}
      onClose={onClose}
      title="Follow-up screening"
      fullWidth
      content={<PhoneScreeningSchedulerForm />}
    />
  );
};
